import LockedOutlinedIcon from '@mui/icons-material/LockOutlined';
import CameraOutlinedIcon from '@mui/icons-material/CameraOutlined';
import WbIncandescentOutlinedIcon from '@mui/icons-material/WbIncandescentOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import NightsStayOutlinedIcon from '@mui/icons-material/NightsStayOutlined';
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";

export const LocationFeatureTypography = styled(Typography)(() => ({
  color: '#2E363E',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '0.857143rem',
  lineHeight: '1.07143rem',
}));

const LocationFeatureIcon = () => ({
  alignSelf: 'center',
});

export const FeatureIconMap = {
  'Manned Security': styled(LockedOutlinedIcon)(LocationFeatureIcon),
  'Fenced / Gated': styled(BlockOutlinedIcon)(LocationFeatureIcon),
  'Yard Cameras': styled(CameraOutlinedIcon)(LocationFeatureIcon),
  'Gate Cameras': styled(CameraOutlinedIcon)(LocationFeatureIcon),
  'Lights': styled(WbIncandescentOutlinedIcon)(LocationFeatureIcon),
  'Paved': styled(LocalShippingOutlinedIcon)(LocationFeatureIcon),
  'M & R Offered': styled(BuildOutlinedIcon)(LocationFeatureIcon),
  'Side-pick / Top-Pick': styled(PublishOutlinedIcon)(LocationFeatureIcon),
  'Daily Inventory Report': styled(AssignmentTurnedInOutlinedIcon)(LocationFeatureIcon),
  '24/7 Access': styled(HistoryOutlinedIcon)(LocationFeatureIcon),
  'Overnight Truck Parking': styled(NightsStayOutlinedIcon)(LocationFeatureIcon),
  'Restrooms': styled(WcOutlinedIcon)(LocationFeatureIcon),
  'Security Certifications': styled(VerifiedUserOutlinedIcon)(LocationFeatureIcon),
  'Hazmat Accepted': styled(WarningAmberOutlinedIcon)(LocationFeatureIcon),
  'Bonded': styled(GavelOutlinedIcon)(LocationFeatureIcon),
  'On-Site Equipment & Service': styled(BuildOutlinedIcon)(LocationFeatureIcon),
}

/**
 * Narrows a feature name to a key of {@link FeatureIconMap}. The API's feature names (`LocationFeatureType`) match
 * these keys, but one added there before it is added here would otherwise render an undefined icon component and
 * crash the page.
 */
export const hasFeatureIcon = (feature: string): feature is keyof typeof FeatureIconMap =>
  Object.prototype.hasOwnProperty.call(FeatureIconMap, feature);
